// extracted by mini-css-extract-plugin
export default {"cardstyle":"ClassCard_cardstyle__U6vW7","paper":"ClassCard_paper__V18qi"};